/* eslint-disable import/prefer-default-export */
import { useQuery } from "@tanstack/react-query";
import { getRateCards } from "api/services/rateCard";
import { rateCardQueryKeys } from "./rateCardQueryKeys";

export const useGetRateCardList = (filters: any) =>
  useQuery({
    queryKey: rateCardQueryKeys.rateCardListing(filters),
    queryFn: ({ signal }) => getRateCards({ params: filters, signal }).then((res) => res.data),
  });
